import React from 'react';
import BaseFactory from './BaseFactory';
import {
  getFaqsAnchorTag,
  getBlogAnchorTag,
  hasLocationHours,
  NoTopMarginParagraph,
  NoBottomMarginParagraph,
  hasCustomDescription,
} from './util';
import { isEmptyArray } from '../../../core/util/array';
import CustomDescriptionSection from './CustomDescriptionSection';
import { SOLV_SECTION_TITLE } from './constants';

class NonPartnerOccupationalHealth extends BaseFactory {
  getDescription() {
    return (
      `${this.clinicName} is an occupational health clinic ` +
      `located at ${this.address}, ${this.city}, ` +
      `${this.state}, ${this.zip} and working with employers and their workforce ` +
      `throughout the area. For more information, call ${this.clinicName}${this.phoneString}.`
    );
  }

  getKeywords() {
    return (
      `${this.clinicName}, ${this.clinicName}, ${this.city}, ${this.clinicName} ${this.zip}, ` +
      `occupational health ${this.city}, occupational health ${this.zip}, ` +
      `walk-in clinic ${this.city}, walk-in clinic ${this.zip}, occ med clinic ${this.city}, ` +
      `occ med clinic ${this.zip}, ${this.city} ${this.state} ` +
      `walk-in clinic, ${this.zip} walk-in clinic`
    );
  }

  getBody() {
    return (
      <div>
        <CustomDescriptionSection location={this.location} />
        <NoTopMarginParagraph>
          {hasCustomDescription(this.location) && (
            <span>
              {SOLV_SECTION_TITLE}
              <br />
            </span>
          )}
          Specializing in occupational medicine, {this.clinicName} provides healthcare services to
          employers and their workforce in and around {this.cityAnchorTag} through their location at{' '}
          {this.fullAddress}.{' '}
          {hasLocationHours(this.location) && (
            <span>
              They are open {this.numDaysOpenString} a week including {this.nextOpenDayName} from{' '}
              {this.nextOpenDayHoursStr}.{' '}
            </span>
          )}
          While they may accept walk-in patients, it may be best to coordinate a visit through your
          employer.
        </NoTopMarginParagraph>
        {isEmptyArray(this.glowingWords) && this.rating && (
          <p>
            <b>{this.clinicName}</b> has an average rating of {this.rating} stars out of 5.
          </p>
        )}
        {!isEmptyArray(this.glowingWords) && !this.rating && (
          <p>
            Patients have used terms like {this.glowingWordsString} when reviewing{' '}
            <b>{this.clinicName}</b>.
          </p>
        )}
        {!isEmptyArray(this.glowingWords) && this.rating && (
          <p>
            <b>{this.clinicName}</b> has an average rating of {this.rating} stars out of 5 with
            patients using terms like {this.glowingWordsString} when reviewing them.
          </p>
        )}
        <NoBottomMarginParagraph>
          If you are looking to learn more about occupational health including statistics, trends,{' '}
          {getFaqsAnchorTag()} and other useful information, check out our {getBlogAnchorTag()} to
          empower your knowledge as a healthcare consumer. {this.cityGuideContent}
        </NoBottomMarginParagraph>
      </div>
    );
  }
}

export default NonPartnerOccupationalHealth;
